export enum CtfStatusEnum {
  NON_DEMARRE = "Non démarré",
  EN_COURS = "En cours",
  TERMINE = "Terminé"
}